var map = {
	"./calendar.svg": 5068,
	"./cash_out.svg": 1252,
	"./chat.svg": 9810,
	"./jobs.svg": 1556,
	"./money.svg": 4278,
	"./payment.svg": 4682,
	"./troopers_protect.svg": 9463
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3192;